<template>
    <v-container fluid fill-height class="login"> <!-- fill-height -->

        <v-container>

            <v-layout wrap justify-center>

                <v-card class="elevation-1 pa-3 login-card">
                    <v-card-text>
                        <!--<div class="layout column align-center">
                            <h1 class="flex my-4 primary--text font-weight-bold">ログイン</h1>
                        </div>-->
                        <v-form ref="loginForm">
                            <v-text-field
                                    append-icon="mdi-account"
                                    name="login"
                                    label="ユーザID"
                                    type="text"
                                    v-model="model.username"
                                    required
                                    maxlength="30"
                                    id="userNameField"
                                    placeholder=" "
                            ></v-text-field>
                            <v-text-field
                                    append-icon="mdi-lock"
                                    name="password"
                                    label="パスワード"
                                    type="password"
                                    v-model="model.password"
                                    :rules="passwordRules"
                                    required
                                    maxlength="32"
                                    id="passwordField"
                                    placeholder=" "
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <div class="login-btn">
                        <v-btn block color="primary" @click="onLoginClick" :loading="isLoading" :id="'loginBtn'">ログイン</v-btn>
                    </div>
                </v-card>

            </v-layout>
        </v-container>

    </v-container>
</template>
<script>
import BaseView from "../../components/BaseView";
import LoginSupport from "../../components/LoginSupport";
import UserAPI from "@/apis/UserAPI";
import {UnauthorizedError} from "@/apis/Api";
import ApiConfig from "@/apis/ApiConfig";

export default {
    mixins:[BaseView,LoginSupport],
    components: {
    },
    props: [],
    data: () => ({
        isInitialized:false,
        isLoading:false,

        condition:{},
        errors:{},

        passwordRules: [
            v => !!v || "パスワードは必須項目です。",
            v => (v && v.length <= 32) || "パスワードは32文字以内で入力してください。"
        ],
        model: {
            username: "",
            password: ""
        }
    }),
    computed: {

    },
    mounted:function() {

    },
    created:function() {
    },
    watch: {

    },
    methods: {

        onLoginClick(){

            let self = this;

            // バリデーション
            if (!this.$refs.loginForm.validate()) {
                return
            }

            this.isLoading = true;
            let username = this.model.username;
            let password = this.model.password;
            console.log("ログインを行います。" + username);

            let apiOption = {
                authCheck: false, // ログイン画面なので事前の認証チェックは行わない
                onUnauthorized: null,
            };

            UserAPI.signin(username,password,apiOption)
                .then( a => {
                    this.isLoading = false;
                    console.log("ログインできたみたいです",a);
                    ApiConfig.setAuthTokenSet(a);
                    this.fireLoginEvent()
                })
                .catch(err => {
                    //console.log("onLoginClickでエラーが発生しました。",err);
               
                    if (err instanceof UnauthorizedError) {
                        //console.log("UnauthorizedErrorがcatchされました。",err);
                        self.showErrorToast("ログインできませんでした。正しいユーザID、パスワードを入力してください。");
                    } else {
                        self.showErrorToast("ログイン時に例外が発生しました。");
                        console.log("ログイン時に例外が発生しました。",err)
                    }
                  
                    this.isLoading = false;
                })                
         
        },

        fireLoginEvent(){
            console.log("fireLoginEvent")
            this.$emit('login', "");
        }


    },

}
</script>